import { render, staticRenderFns } from "./UptimeReport.vue?vue&type=template&id=96b25644&"
import script from "./UptimeReport.vue?vue&type=script&lang=js&"
export * from "./UptimeReport.vue?vue&type=script&lang=js&"
import style0 from "./UptimeReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports